import { render, staticRenderFns } from "./mdPage.vue?vue&type=template&id=1ac51b3a&scoped=true&"
import script from "./mdPage.vue?vue&type=script&lang=js&"
export * from "./mdPage.vue?vue&type=script&lang=js&"
import style0 from "./mdPage.vue?vue&type=style&index=0&id=1ac51b3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac51b3a",
  null
  
)

export default component.exports